import UserInternalTransfers from './UserInternalTransfers';

export default UserInternalTransfers;
